export type ScoringFormCommand = {
  commandName: string;
  commandProps: Record<string, unknown>;
};

export enum ScoringFormsEnum {
  THIGH_FAT_FRACTION_SCORING_FORM = 'THIGH_FAT_FRACTION_SCORING_FORM',
  RANO_BASELINE_VISIT_SCORING_FORM = 'RANO_BASELINE_VISIT_SCORING_FORM',
  RANO_FOLLOWUP_VISIT_SCORING_FORM = 'RANO_FOLLOWUP_VISIT_SCORING_FORM',
  RANO_PATIENT_SCORING_FORM = 'RANO_PATIENT_SCORING_FORM',
  RECIST_1_1_SCORING_FORM = 'RECIST_1_1_SCORING_FORM',
}

/** Forms where lesions may be deleted only from the end of each index sequence (LIFO). */
export const LIFO_DELETE_FORMS: ReadonlySet<string> = new Set([
  ScoringFormsEnum.RANO_BASELINE_VISIT_SCORING_FORM,
  ScoringFormsEnum.RANO_FOLLOWUP_VISIT_SCORING_FORM,
  ScoringFormsEnum.RANO_PATIENT_SCORING_FORM,
  ScoringFormsEnum.RECIST_1_1_SCORING_FORM,
]);
